import React from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import { useNavigate } from 'react-router-dom'

const BREADCRUMB_SX = {
  fontFamily: "'Maven Pro', sans-serif",
  fontSize: '12px',
  color: 'var(--vo-slate)',
  lineHeight: 1,
}

export const PageHeader = ({ title, segments, actions, ...otherProps }) => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '24px 0 16px',
        gap: '12px',
      }}
      {...otherProps}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
        {segments.length > 0 && (
          <Box component="nav" sx={{ display: 'flex', alignItems: 'center' }}>
            {segments.map((segment, index) => (
              <React.Fragment key={`${segment.label}-${index}`}>
                {index > 0 && (
                  <Box component="span" aria-hidden="true" sx={{ ...BREADCRUMB_SX, padding: '0 4px' }}>
                    /
                  </Box>
                )}
                {segment.route ? (
                  <Box
                    component="button"
                    type="button"
                    onClick={() => navigate(segment.route)}
                    sx={{
                      ...BREADCRUMB_SX,
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      margin: 0,
                      cursor: 'pointer',
                      '&:hover': { color: 'var(--vo-celeste)' },
                    }}
                  >
                    {segment.label}
                  </Box>
                ) : (
                  <Box component="span" sx={BREADCRUMB_SX}>
                    {segment.label}
                  </Box>
                )}
              </React.Fragment>
            ))}
          </Box>
        )}
        <Box
          component="h1"
          sx={{
            fontFamily: "'Rubik', sans-serif",
            fontSize: '22px',
            fontWeight: 700,
            color: 'var(--vo-ink)',
            margin: 0,
            lineHeight: 1.2,
          }}
        >
          {title}
        </Box>
      </Box>
      {actions && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
          {actions}
        </Box>
      )}
    </Box>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      route: PropTypes.string,
    })
  ),
  actions: PropTypes.node,
}

PageHeader.defaultProps = {
  segments: [],
  actions: null,
}
